import axios from 'axios'
import { templates } from '../../utils';
import { AppUrls } from '../../services/Globals';
import { Config } from '../../services/Config';

export const identityValFunctions = {}

identityValFunctions.getNewFieldNames = (name) => {
  // console.log("getNewFieldNames--------------NAME-----: ", name)
  // console.log("templates--------------: ", templates)
  // console.log("templates------templates.filter(doc => doc.DocumentType == name)--------: ", templates.filter(doc => doc.DocumentType === name))

  const fields = templates.filter(doc => doc.DocumentType === name).map((docSet) => docSet.Fields)
  // console.log("templates------fields--------: ", fields)
  return fields.reduce((a, b) => [...a, ...b], [])
}

identityValFunctions.docRequest = async (docId) => {


  let handleResponse = (response) => {
    let respObject = response.data;
    if (!respObject.IsOK) {
      let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
      let error = (respObject.Body || responseObject);
      return Promise.reject(error);
    } else {
      console.log('response', respObject)
      return respObject;
    }
  }

  return axios.post(
    AppUrls.DownloadSection,
    Config.SetParameters(docId, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)

}

